<template>
  <div class="content">
    <div class="folder-control-wrap">
      <div class="frm-row">
        <span class="frm-label">元の場所</span>
        <select
          class="frm-select frm-size-mx"
          v-model="showTarget"
          @change="selectShowTarget"
          ref="newAddButton"
        >
          <!-- No4:スキャナ保存対応「ファイル一覧画面（ゴミ箱）」画面でプルダウンの文言変更 -->
          <option value="0">電子取引・スキャナ保存</option>
          <option value="1">その他</option>
        </select>
      </div>

      <div class="frm-row">
        <div class="frm-item grow left">
          <!-- 元に戻す -->
          <button
            class="frm-btn-control strong hd-btn"
            v-if="this.show.btnRestore"
            @click="dialog"
            value="restore"
          >
            元に戻す
          </button>

          <!-- 完全に削除-->
          <button
            class="frm-btn-control strong hd-btn"
            v-if="this.show.btnDelete"
            v-show="this.showTarget == '1'"
            type="button"
            @click="dialog"
            value="delete"
          >
            完全に削除
          </button>
        </div>

        <div class="frm-item grow right" style="margin: 3px 0 0">
          <!-- <div class="frm-search has-ico frm-size-l">
            <input
              type="search"
              class="frm-search-text"
              placeholder="検索キーワード"
              v-model.trim="searchKeyword"
              @input="eventSearchKeyword"
              maxlength="255"
            />
          </div> -->
          <div class="frm-search has-ico frm-size-l none-border-left" :class="{'setvalue': searchKeywordFlag}">
            <input
              type="search"
              class="frm-search-text"
              placeholder="検索キーワード"
              v-model.trim="searchKeyword"
              maxlength="255"
            />
          </div>
          <!-- <button
            class="frm-btn-control ico ico-filter"
            @click="clickShowFilter"
          ></button> -->
          <!-- <button
            :disabled="!searchKeywordFlag && !showTargetFlag"
            class="frm-btn-control ico ico-filter-close"
            @click="clickClearFilter"
          ></button> -->
        </div>
      </div>
    </div>

    <p class="frm-item alignright" style="margin-top: 10px">{{ collectedDocuments.length.toLocaleString() }}<span v-show="!this.searchKeyword == ''">/{{ dataCount.length.toLocaleString() }}</span>件
    </p>
    <!-- ******************************************************************
        *     ファイル一覧_ごみ箱                                          *
    ******************************************************************-->
    <div class="table-section">  
      <div class="table-wrap" @dragover.prevent="dragFile">
        <table ref="fileListTable" class="table-select table-multiCheckList">
          <colgroup>
            <col style="width: 40px" />
            <col class="auto-col" >
            <col class="auto-col" >
            <col style="width: 200px" />
            <col style="width: 100px" />
            <col style="width: 100px" />
          </colgroup>

          <thead>
            <tr>
              <th class="multi-select-item">
                <label class="frm-checkbox">
                  <!-- <input
                    type="checkbox"
                    :checked="isAllSelected"
                    @change="allCheckFileList"
                    @click="clickheadSelect"
                  /> -->
                  <input
                    type="checkbox"
                    :checked="isAllSelected"
                    @click="allCheckFileList"
                    :disabled="collectedDocuments.length == 0"
                  />
                  <!-- <input ref="allCheckBox" type="checkbox" :checked="chkAllCheckFileList" @click="allCheckFileList"> -->
                  <span class="checkbox-item" tabindex="0" @keydown.space.stop.prevent="allCheckFileList" ></span>
                </label>
              </th>
              <th class="alignleft" @click="sortBy('name')">
                名称
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedNameClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedNameClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="alignleft" @click="sortBy('originalFolderPath')">
                元の場所
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedOriginalFolderPathClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedOriginalFolderPathClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="alignleft" @click="sortBy('deleteUser')">
                移動者
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedDeleteUserClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedDeleteUserClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="aligncenter" @click="sortBy('deleteDate')">
                移動日時
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedDeleteDateClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedDeleteDateClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="aligncenter" @click="sortBy('updateDate')">
                保存日時
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedUpdateDateClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedUpdateDateClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="info in collectedDocuments"
              :key="info.fileId"
              :class="{
                selected: this.selectedFileIdList.includes(info.fileId),
              }"
            >
              <td class="alignleft">
                <!-- <label class="frm-checkbox" tabindex="0" @blur="onblur"> -->
                <label class="frm-checkbox">
                  <input
                    v-bind:id="'chk' + info.fileId"
                    type="checkbox"
                    v-bind:value="info.fileId"
                    v-model="selectedFileIdList"
                    @click="selectRow(info.fileId)"
                  />
                  <span class="checkbox-item" tabindex="0" @keydown.space.stop.prevent="selectRow(info.fileId)"></span>
                </label>
              </td>

              <!------ 名称 ------>
              <td
                class="alignleft"
                v-if="info.listType == '0'"
                @click="selectRow(info.fileId)"
              >
                <div class="folder-name-wrap">
                  <div class="folder-state-wrap">
                    <span class="folder-state-ico ico-folder"></span>
                  </div>
                  <span>{{ info.name }}</span>
                </div>
              </td>
              <td
                class="alignleft"
                v-if="info.listType != '0'"
                @click="selectRow(info.fileId)"
              >
                <div class="folder-name-wrap">
                  <div class="folder-state-wrap">
                    <span class="folder-state-ico ico-file"></span>
                  </div>
                  <span>{{ info.name }}</span>
                </div>
              </td>

              <!------ 元の場所 ------>
              <td class="alignleft" @click="selectRow(info.fileId)">
                <span>{{ info.originalFolderPath }}</span>
              </td>
              <!------ 移動者 ------>
              <td class="alignleft" @click="selectRow(info.fileId)">
                <span>{{ info.deleteUser }}</span>
              </td>
              <!------ 移動日時 ------>
              <td class="aligncenter" @click="selectRow(info.fileId)">
                <span>{{ formatDateTime(info.deleteDate) }}</span>
              </td>
              <!------ 保存日時 ------>
              <td class="aligncenter" @click="selectRow(info.fileId)">
                <span>{{ formatDateTime(info.updateDate) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table-select single-select" v-show="noDataPrompt">
          <tbody>
            <tr>
              <p class="noData-area">
                {{ noDataMsg }}
              </p>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
       _/                                                                                                                    _/
       _/      子画面定義：                                                                                                   _/
       _/      ダイアログ定義：「完全に削除」処理の確認ダイアログ(ConfirmDialog)                    　                                           _/
       _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
  <ConfirmDialog
    :isShow="isShow"
    :message="content"
    :width="width"
    @confirm="confirm(process)"
    @cancel="cancel"
  ></ConfirmDialog>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import Common from "@/util/common.js";
import { mapGetters, mapMutations } from "vuex";
import { convert_to_gemmdd } from "@/util/dateFormat.js";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import {
  API_STFMFM02C04_Initialize,
  API_STFMFM02C04_Restore,
  API_STFMFM02C04_Delete,
  API_STFMFM02C04_SaveFilter,
} from "@/api/Modules/FM02/STFMFM02C04.js";

export default {
  name: "STFMFM02C04",
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      sessionID: "",
      collectedDocuments: [],
      dataCount: [],
      errors: [],
      businessOperatorId: "0", //ユーザの種類
      userFolderFileAutFlag: false, //フォルダ・ファイルの操作【作成/編集/削除/移動/複写】権限
      userFileAuthFlag: false, //ファイルの操作【登録/編集/削除/移動/複写】権限
      selectedFileIdList: [], //チェックボックスIDリスト
      showTarget: "0", // 0:電子取引・スキャナ保存、1:その他  // No4:スキャナ保存対応 プルダウン
      searchKeyword: "",
      searchKeywordFlag: false,
      showTargetFlag: false,
      noDataPrompt: false,
      noDataMsg: Common.getMessage("MTCL1118", ["ファイル"]), //検索結果0件時のメッセージ
      // 処理確認ダイアログ
      width: "500",
      isShow: false,
      content: "",
      process: "",
      // content: Common.getMessage("MTFM5150", []), //完全に削除処理確認ダイアログ_メッセージ
      isAllSelected: false, //ヘッダー行チェックボックスFlag
      selectItemList: {}, //選択（チェック）されたデータの情報リスト
      show: {
        btnRestore: false, //元に戻すボタン
        btnDelete: false, //完全に削除ボタン
      },
      sort: {
        indexName: 2, // 名前
        indexOriginalFolderPath: 2, // 元の場所
        indexDeleteUser: 2, // 移動者
        indexDeleteDate: 2, // 移動日時
        indexUpdateDate: 1, // 保存日時
        sortedNameClass: 0, // 名前cssスタイルクラス
        sortedOriginalFolderPathClass: 0, // 元の場所cssスタイルクラス
        sortedDeleteUserClass: 0, // 移動者cssスタイルクラス
        sortedDeleteDateClass: 0, // 移動日時cssスタイルクラス
        sortedUpdateDateClass: 0, // 保存日時cssスタイルクラス
        key: "", // ソートキー
        isAsc: false, // 昇順ならtrue,降順ならfalse
      },
    };
  },
  watch: {
    searchKeyword: {
      handler: "eventSearchKeyword",
      //immediate: true,
    },
  },
  computed: {
    ...mapGetters("businessModule", ["isDeleteShow"]),
  },
  methods: {
    // No8データ容量表示領域更新対応
    ...mapMutations("businessModule", ["confirmDialogue", "processDialogue","updateDataSpaceUsedChangeFlag"]),

    // **********************************************
    // * ファイル又はフォルダを元に戻す
    // **********************************************
    restore() {
      this.isShow = false;
      this.processDialogue(true);
      this.errors = [];

      let fileIdList = []; //元に戻すファイルIDリスト
      let folderIdList = []; //元に戻すフォルダIDリスト
      var filterInfo = Array.from(this.allData);

      filterInfo = filterInfo.filter((item) => {
        return this.selectedFileIdList.includes(item.fileId);
      });

      for (var i = 0; i < filterInfo.length; i++) {
        if (filterInfo[i].listType == "0") {
          //フォルダ
          folderIdList.push(filterInfo[i].folderKey);
        } else {
          //ファイル
          fileIdList.push(filterInfo[i].fileKey);
        }
      }

      let params = {
        folderKeyList: folderIdList,
        fileKeyList: fileIdList,
      };
      //ファイル管理サービスクラス.Restoreの呼び出し
      API_STFMFM02C04_Restore(params).then((response) => {
        if (response.result == "0000") {
          this.getTrashHeaderList(); //ごみ箱ヘッダー情報再取得
        } else {
          var errParaList = [];
          var errCd = response.errorCD;
          // 機能利用権限ない
          if (_.eq(errCd, "MTFM1020")) {
            if (this.businessOperatorId == "0") {
              errParaList.push("管理者(システム所有者)");
            } else {
              errParaList.push("税理士事務所");
            }
          }
          // データがない
          else if (_.eq(errCd, "MTFM1400")) {
            this.getTrashHeaderList(); //ごみ箱ヘッダー情報再取得
          }
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, errParaList)
            )
          );
        }
        this.selectedFileIdList = [];
        this.isAllSelected = false;
        this.setErrors();
        this.processDialogue(false);
      });
    },

    // **********************************************
    // * 完全に削除ボタン押下時に表示される処理確認画面の表示/設定
    // **********************************************
    dialog(e) {
      this.errors = [];
      this.process = e.target.value;

      if (this.process == "delete") {
        if (this.selectedFileIdList.length == 0) {
          this.errors.push(
            Common.createError("MTFM1010", Common.getMessage("MTFM1010", []))
          );
        } else {
          this.content = Common.getMessage("MTFM5150", []);
          this.isShow = true;
        }
      } else if (this.process == "restore") {
        if (this.selectedFileIdList.length == 0) {
          this.errors.push(
            Common.createError("MTFM1010", Common.getMessage("MTFM1010", []))
          );
        } else {
          this.content = Common.getMessage("MTFM5190", []);
          this.isShow = true;
        }
      }
      this.setErrors();
    },

    // **********************************************
    // * 完全に削除_ダイアログでキャンセルが選択された時の処理
    // **********************************************
    cancel() {
      this.process = "";
      this.isShow = false;
    },

    // **********************************************
    // * 完全に削除_ダイアログでOKが選択された時の処理
    // **********************************************
    confirm(process) {
      if (process == "restore") {
        this.restore();
      } else if (process == "delete") {
        this.delete();
      }
      this.process = "";
    },

    // **********************************************
    // *
    // **********************************************
    delete() {
      this.isShow = false;
      this.processDialogue(true);
      this.errors = [];
      let fileIdList = []; //完全に削除するファイルIDリスト
      let folderIdList = []; //完全に削除するフォルダIDリスト
      var filterInfo = Array.from(this.allData); //ファイル一覧情報

      filterInfo = filterInfo.filter((item) => {
        return this.selectedFileIdList.includes(item.fileId);
      });

      for (var i = 0; i < filterInfo.length; i++) {
        if (filterInfo[i].listType == "0") {
          //フォルダ
          folderIdList.push(filterInfo[i].folderKey);
        } else {
          //ファイル
          fileIdList.push(filterInfo[i].fileKey);
        }
      }

      let params = {
        folderKeyList: folderIdList,
        fileKeyList: fileIdList,
      };
      //ファイル管理サービスクラス.deleteの呼び出し
      API_STFMFM02C04_Delete(params).then((response) => {
        if (response.result == "0000") {
          //ごみ箱ヘッダー情報再取得
          this.getTrashHeaderList();
          // No8データ容量表示領域更新対応
          this.updateDataSpaceUsedChangeFlag(true)
        } else {
          var errParaList = [];
          var errCd = response.errorCD;
          // 機能利用権限ない
          if (_.eq(errCd, "MTFM1020")) {
            if (this.businessOperatorId == "0") {
              errParaList.push("管理者(システム所有者)");
            } else {
              errParaList.push("税理士事務所");
            }
          }
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, errParaList)
            )
          );
        }
        // 画面制御
        this.visibleSetting();
        this.selectedFileIdList = [];
        this.isAllSelected = false;
        this.setErrors();
        this.processDialogue(false);
      });
    },
    // **********************************************
    // * 表示対象変更・検索
    // **********************************************
    selectShowTarget() {
      this.clearSort();
      this.searchKeyword = "";
      //選択ファイル初期化
      this.selectedFileIdList = [];
      //ヘッダー行のチェックボックスOFF
      this.isAllSelected = false;
      //検索処理
      this.searchFile();
      //DynamoDBにフィルタ条件を保存する
      this.saveFilter();
    },
    // **********************************************
    // * 検索キーワード検索・フィルタ検索
    // **********************************************
    eventSearchKeyword(e) {
      this.clearSort();
      //this.searchKeyword = e.target.value;
      //選択ファイル初期化
      this.selectedFileIdList = [];
      //ヘッダー行のチェックボックスOFF
      this.isAllSelected = false;
      // 検索処理
      this.searchFile();
      //DynamoDBにフィルタ条件を保存する
      this.saveFilter();
    },

    initFocus() {
      this.$refs.newAddButton.focus();
    },
    // **********************************************
    // * 日付のフォーマット(gemmdd)
    // **********************************************
    formatDate(value) {
      if (value) {
        return convert_to_gemmdd(new Date(value), 2, 2);
      }
    },
    // **********************************************
    // * 日付のフォーマット(YYYY/MM/DD HH:mm:ss)
    // **********************************************
    formatDateTime(value) {
      if (value) {
        return moment(String(value)).format("YYYY/MM/DD HH:mm:ss");
      }
    },
    formatDateTimeInt(value) {
      if (value) {
        return moment(String(value)).format("YYYYMMDD HHmmss");
      }
    },
    // **********************************************
    // * 行選択
    // **********************************************
    selectRow(fileId) {
      if (this.selectedFileIdList.includes(fileId)) {
        let index = this.selectedFileIdList.indexOf(fileId);

        this.selectedFileIdList.splice(index, 1);
      } else {
        this.selectedFileIdList.push(fileId);
      }
      this.isAllSelected = this.isAllCheckFileList();
    },

    allCheckFileList() {
      this.isAllSelected = !this.isAllSelected;
      if (this.isAllSelected) {
        this.selectedFileIdList = [];
        for (var i = 0; i < this.collectedDocuments.length; i++) {
          this.selectedFileIdList.push(this.collectedDocuments[i].fileId);
        }
      } else {
        this.selectedFileIdList = [];
      }
    },

    isAllCheckFileList() {
      return (this.selectedFileIdList.length == this.dataCount.length);
    },

    // **********************************************
    // * フィルタ条件を保存
    // **********************************************
    saveFilter() {
      this.errors = [];
      let params = {
        showTarget: this.showTarget, //表示対象
        searchKeyword: this.searchKeyword, //検索キーワード
      };

      //DynamoDBにフィルタ条件を保存
      API_STFMFM02C04_SaveFilter(params).then((response) => {
        if (response.result != "0000") {
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
        this.setErrors();
      });
    },
    // **********************************************
    // * 検索処理
    // **********************************************
    searchFile() {
      var filterInfo = Array.from(this.allData);

      this.dataCount = filterInfo.filter((item) => {
        return (
          //表示対象
          item.showTarget == this.showTarget
        );
      });

      filterInfo = filterInfo.filter((item) => {
        return (
          //表示対象、名称、元の場所、移動者、移動日時、保存日
          item.showTarget == this.showTarget &&
          (item.name.includes(this.searchKeyword) ||
            item.originalFolderPath.includes(this.searchKeyword) ||
            item.deleteUser.includes(this.searchKeyword) ||
            this.formatDateTime(item.updateDate).includes(this.searchKeyword) ||
            this.formatDateTime(item.deleteDate).includes(this.searchKeyword))
        );
      });

      this.collectedDocuments = filterInfo;

      if (this.searchKeyword != "") {
        this.searchKeywordFlag = true;
      } else {
        this.searchKeywordFlag = false;
      }
      if (this.showTarget != "0") {
        this.showTargetFlag = true;
      } else {
        this.showTargetFlag = false;
      }
      if (
        this.collectedDocuments.length == 0 ||
        this.collectedDocuments.length == null
      ) {
        this.noDataPrompt = true;
      } else {
        this.noDataPrompt = false;
      }
    },

    // **********************************************
    // *ごみ箱ヘッダー情報取得
    // **********************************************
    getTrashHeaderList() {
      let params = {
        showTarget: this.showTarget, //表示対象
        searchKeyword: this.searchKeyword, //検索キーワード
      };

      //ファイル管理サービスクラス.GetTrashHeaderListの呼び出し
      API_STFMFM02C04_Initialize(params).then((response) => {
        if (response.result == "0000") {
          //正常時
          this.allData = response.collectDataList;
          this.collectedDocuments = response.collectDataList;
          this.showTarget = response.showTarget;
          this.searchKeyword = response.searchKeyword;
          this.businessOperatorId = response.businessOperatorId;

          //データが0件の場合、メッセージを表示
          if (
            this.collectedDocuments.length == 0 ||
            this.collectedDocuments.length == null
          ) {
            this.noDataPrompt = true;
          } else {
            this.noDataPrompt = false;
          }
          if (response.userFolderFileAuthFlag != null) {
            this.userFolderFileAuthFlag = response.userFolderFileAuthFlag;
          }
          if (response.userFileAuthFlag != null) {
            this.userFileAuthFlag = response.userFileAuthFlag;
          }
          //検索処理
          this.searchFile();
        } else {
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
        // 画面制御
        this.visibleSetting();
      });
    },

    // **********************************************
    // *画面制御処理
    // **********************************************
    visibleSetting() {
      // ユーザの種類が税理士事務所の場合
      if (this.businessOperatorId == "0") {
        // ユーザのフォルダ・ファイルの操作権限がある場合
        if (this.userFolderFileAuthFlag) {
          this.show.btnRestore = true;
          this.show.btnDelete = true;
          // ユーザのフォルダ・ファイルの操作権限がない場合
        } else {
          // ファイルの操作権限がある場合
          if (this.userFileAuthFlag) {
            this.show.btnRestore = true;
            this.show.btnDelete = true;
            // ファイルの操作権限がない場合
          } else {
            this.show.btnRestore = false;
            this.show.btnDelete = false;
          }
        }
        // ユーザの種類が事業所の場合
      } else {
        this.show.btnRestore = true;
        this.show.btnDelete = true;
      }
    },

    // **********************************************
    // *ソート
    // **********************************************
    sortBy(key) {
      // isAsc 昇順ならtrue,降順ならfalse
      this.sort.isAsc = true;
      this.sort.key = key;

      // 値を退避
      let value = "";
      if (key == "name") {
        value = this.sort.indexName;
      } else if (key == "originalFolderPath") {
        value = this.sort.indexOriginalFolderPath;
      } else if (key == "deleteUser") {
        value = this.sort.indexDeleteUser;
      } else if (key == "deleteDate") {
        value = this.sort.indexDeleteDate;
      }else if (key == "updateDate") {
        value = this.sort.indexUpdateDate;
      }

      // 昇順、降順
      if (value == 0) {
        this.sort.isAsc = true;
      } else if (value == 1) {
        this.sort.isAsc = false;
      }

      // 「▲」、「▼」クラスを削除
      this.sort.sortedNameClass = 0;
      this.sort.sortedOriginalFolderPathClass = 0;
      this.sort.sortedDeleteUserClass = 0;
      this.sort.sortedDeleteDateClass = 0;
      this.sort.sortedUpdateDateClass = 0;
      // 既定値に戻す
      this.sort.indexName = 2;
      this.sort.indexOriginalFolderPath = 2;
      this.sort.indexDeleteUser = 2;
      this.sort.indexDeleteDate = 2;
      this.sort.indexUpdateDate = 1;

      if (key == "name") {
        this.sort.indexName = (value % 2) + 1;
        this.sort.sortedNameClass = this.sort.indexName;
      } else if (key == "originalFolderPath") {
        this.sort.indexOriginalFolderPath = (value % 2) + 1;
        this.sort.sortedOriginalFolderPathClass = this.sort.indexOriginalFolderPath;
      } else if (key == "deleteUser") {
        this.sort.indexDeleteUser = (value % 2) + 1;
        this.sort.sortedDeleteUserClass = this.sort.indexDeleteUser;
      } else if (key == "deleteDate") {
        this.sort.indexDeleteDate = (value % 2) + 1;
        this.sort.sortedDeleteDateClass = this.sort.indexDeleteDate;
      } else if (key == "updateDate") {
        this.sort.indexUpdateDate = (value % 2) + 1;
        this.sort.sortedUpdateDateClass = this.sort.indexUpdateDate;
      }
      this.sortFileList();
    },

    sortFileList() {
      var fileList = Array.from(this.collectedDocuments);
      // ソート実施
      if (this.sort.key != "") {
        // 名前
        if (this.sort.key == "name" && this.sort.indexName != 0) {
          if (this.sort.isAsc) {
            fileList.sort(function (a, b) {
              return a.listType > b.listType ? 1 : a.listType < b.listType ? -1 : a.name >= b.name ? 1 : -1;
            });
          } else {
            fileList.sort(function (a, b) {
              return a.listType > b.listType ? -1 : a.listType < b.listType ? 1 : a.name > b.name ? -1 : 1;
            });
          }
        } else if (
          this.sort.key == "originalFolderPath" &&
          this.sort.indexOriginalFolderPath != 0
        ) {
          if (this.sort.isAsc) {
            fileList.sort(function (a, b) {
              return a.listType > b.listType ? 1 : a.listType < b.listType ? -1 : a.originalFolderPath >= b.originalFolderPath ? 1 : -1;
            });
          } else {
            fileList.sort(function (a, b) {
              return a.listType > b.listType ? -1 : a.listType < b.listType ? 1 : a.originalFolderPath > b.originalFolderPath ? -1 : 1;
            });
          }
        } else if (
          this.sort.key == "deleteUser" &&
          this.sort.indexDeleteUser != 0
        ) {
          if (this.sort.isAsc) {
            fileList.sort(function (a, b) {
              return a.listType > b.listType ? 1 : a.listType < b.listType ? -1 : a.deleteUser >= b.deleteUser ? 1 : -1;
            });
          } else {
            fileList.sort(function (a, b) {
              return a.listType > b.listType ? -1 : a.listType < b.listType ? 1 : a.deleteUser > b.deleteUser ? -1 : 1;
            });
          }
        } else if (
          this.sort.key == "deleteDate" &&
          this.sort.indexDeleteDate != 0
        ) {
          if (this.sort.isAsc) {
            fileList.sort(function (a, b) {
              return a.listType > b.listType ? 1 : a.listType < b.listType ? -1 : a.deleteDate >= b.deleteDate ? 1 : -1;
            });
          } else {
            fileList.sort(function (a, b) {
              return a.listType > b.listType ? -1 : a.listType < b.listType ? 1 : a.deleteDate > b.deleteDate ? -1 : 1;
            });
          }
        } else if (
          this.sort.key == "updateDate" &&
          this.sort.indexUpdateDate != 0
        ) {
          if (this.sort.isAsc) {
            fileList.sort(function (a, b) {
              return a.listType > b.listType ? 1 : a.listType < b.listType ? -1 : a.updateDate >= b.updateDate ? 1 : -1;
            });
          } else {
            fileList.sort(function (a, b) {
              return a.listType > b.listType ? -1 : a.listType < b.listType ? 1 : a.updateDate > b.updateDate ? -1 : 1;
            });
          }
        }
      }
      
      this.collectedDocuments = fileList;
    },
    clearSort() {
      // 「▲」、「▼」クラスを削除
      this.sort.sortedNameClass = 0;
      this.sort.sortedOriginalFolderPathClass = 0;
      this.sort.sortedDeleteUserClass = 0;
      this.sort.sortedDeleteDateClass = 0;
      this.sort.sortedUpdateDateClass = 0;
      // 既定値に戻す
      this.sort.indexName = 2;
      this.sort.indexOriginalFolderPath = 2;
      this.sort.indexDeleteUser = 2;
      this.sort.indexDeleteDate = 2;
      this.sort.indexUpdateDate = 1;
    },

    // 親画面にエラーを設定
    setErrors() {
      this.$emit("getErrors", this.errors);
    },

    onblur(e){
      if(!e) return;
      this.initFocus();
    },
  },
  created() {
    let dateTime = [];
    const time = moment().format("YYYY/MM/DD");
  },
  mounted() {
    var selection = getSelection();
    selection.empty();

    this.processDialogue(true);

    this.initFocus();
    window.addEventListener("resize", this.calculateWindowWidth);

    // 画面再描画(F5、Ctrl+F5、Ctrl+R)
    window.addEventListener("load", (e) => {
      this.selectedFileIdList = new Array();
    });

    this.errors = [];
    let params = {
      showTarget: this.showTarget, //表示対象
      searchKeyword: this.searchKeyword, //検索キーワード
    };
    //ファイル管理サービスクラス.GetTrashHeaderListの呼び出し
    API_STFMFM02C04_Initialize(params).then((response) => {
      if (response.result == "0000") {
        //正常時
        this.allData = response.collectDataList;
        this.collectedDocuments = response.collectDataList;
        this.showTarget = response.showTarget;
        this.searchKeyword = response.searchKeyword;
        this.businessOperatorId = response.businessOperatorId;

        //データが0件の場合、メッセージを表示
        if (
          this.collectedDocuments.length == 0 ||
          this.collectedDocuments.length == null
        ) {
          this.noDataPrompt = true;
        } else {
          this.noDataPrompt = false;
        }
        if (response.userFolderFileAuthFlag != null) {
          this.userFolderFileAuthFlag = response.userFolderFileAuthFlag;
        }
        if (response.userFileAuthFlag != null) {
          this.userFileAuthFlag = response.userFileAuthFlag;
        }
        //検索処理
        this.searchFile();
      } else {
        // エラー表示
        this.errors.push(
          Common.createError(
            response.errorCD,
            Common.getMessage(response.errorCD, [])
          )
        );
      }
      // 画面制御
      this.visibleSetting();
      this.setErrors();
      this.processDialogue(false);
      selection.empty();
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.calculateWindowWidth);
  },
};
</script>

<style scoped>
.frm-checkbox .checkbox-text {
  margin-left: 7.5px;
}
.number-search {
  font-size: 1.4rem;
  margin-bottom: 0;
}
.hd-btn {
  width: 190px;
}
/* No4:スキャナ保存対応 プルダウンの幅 */
.frm-select{
  width: 200px;
}

.height-38{
  height: 38px;
}

.frm-label-wrap{
  display: flex;
  align-items: center;
}
.frm-label-wrap>.frm-label{
  margin-left: 0;
  min-width: 2em;
}
.frm-row>.frm-item.right, .frm-row>.frm-item.left{
  column-gap:10px;
}
.auto-col{
  width: auto;
  min-width: 185px;
}

@media (max-width: 768px) {
  .body>.inner{
    padding-left:20px;
    padding-right:20px;
  }
  .folder-control-wrap .frm-search{
    width:calc(100vw - 60px);
    margin-left: 0;
  }
  .frm-row>.frm-item.right {
    justify-content:flex-start;
  }
  .frm-item>.frm-btn-control:nth-of-type(1){
    /* margin-left: 0; */
  }
  .table-section{
    width:100%;
    max-width:100%;
  }
  .table-wrap{
    width: 100%;
    overflow-x: auto;
    overflow-y:hidden ;
    padding-bottom: 40px;
  }
  .frm-row{
    height: unset;
  }
  .frm-row .frm-label{
    width: unset;
  }
  .frm-row>.frm-item.left{
    justify-content: center;
  }
  .frm-row>.frm-item.left >.frm-btn-control{
    width:130px;
  }
  .frm-row>.frm-item.left >.frm-btn-control:last-child{
    margin-left: 0;
  }
  .auto-col{
    width:185px;
  }
  .frm-item.alignright{
    text-align: left;
  }
}
</style>